import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import SettingIcon from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import HomeIcon from "@mui/icons-material/Home";
import "./Header.css";
export default function AccountMenuNew() {
  const menuPadding = { padding: "12px 16px" };
  const onHoverMenu = {
    "&:hover": {
      backgroundColor: "var(--db-secondary-gray-four)",
    },
  };

  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const handleClick = () => {
    setMenuOpen(!menuOpen);
  };

  const handleClose = () => {
    setMenuOpen(false);
  };

  // Click anywhere outside the menu to close it
  // This effect adds an event listener to the document when the menu is open
  useEffect(() => {
    if (!menuOpen) {
      return;
    }

    function handleClickOutside(event) {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <div className="account-menu-container">
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <IconButton
          ref={buttonRef}
          onClick={handleClick}
          size="small"
          sx={{ height: 40, width: 40 }}
          aria-haspopup="true"
          aria-expanded={menuOpen ? "true" : undefined}
        >
          <Avatar sx={{ width: 40, height: 40, color: "rgb(10, 154, 10)" }} />
        </IconButton>
      </Box>

      {menuOpen && (
        <div className="account-menu" ref={menuRef}>
          {/* <MenuItem
            onClick={() => {
              navigate(`/agents`);
              handleClose();
            }}
            style={menuPadding}
            sx={{
              ...onHoverMenu,
              "&:hover": {
                ...onHoverMenu["&:hover"],
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              },
            }}
          >
            <ListItemIcon>
              <HomeIcon fontSize="small" />
            </ListItemIcon>
            Home
          </MenuItem> */}
          <MenuItem
            onClick={() => {
              navigate("/agents");
              handleClose();
            }}
            style={menuPadding}
          >
            <ListItemIcon>
              <HomeIcon fontSize="small" />
            </ListItemIcon>
            Home
          </MenuItem>
          <MenuItem
            onClick={() => {
              navigate("/settings");
              handleClose();
            }}
            style={menuPadding}
          >
            <ListItemIcon>
              <SettingIcon fontSize="small" />
            </ListItemIcon>
            Settings
          </MenuItem>
          <MenuItem
            onClick={() => {
              localStorage.clear();
              sessionStorage.clear();
              navigate(`/`);
              handleClose();
            }}
            style={menuPadding}
            sx={{
              ...onHoverMenu,
              "&:hover": {
                ...onHoverMenu["&:hover"],
                borderBottomLeftRadius: "8px",
                borderBottomRightRadius: "8px",
              },
            }}
          >
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </div>
      )}
    </div>
  );
}
